
import { Component, Vue, Prop } from "vue-property-decorator";
import {
  IDefaultShippingOrderModel,
} from "@/api/types";
import {
  getPiDetail,
  getPiCustomerShipmentStatus,
  confirmOrder,
  downloadPiDetail,
  downloadPiTemplate,
  uploadPiDetail,
  updatePiShipmentQuantity,
  updatePiDeliveryQuantity,
  updatePiSupplier,
  deletePiDetail,
  updatePiRemark,
  putShippingRemark,
  copyPiDetail,
  getPiInfo,
  updatePIAndCaiGou,
  downloadOtherInfo,
  updateBrand,
  downloadPiPackageInfo,
  updatePIDiscountAndProfit,
  putPoNumber,
  updatePiPurchaseOrderGroup,
  updatepurchaseUnitPrice,
  updateBatchNumber,
  updateOrderRelation,
  getUpdatePo,
  deleteCombinedUnit, downloadLabelInfo, downloadBackupOtherInfo, specifySample, cancelSpecifySample, updateProductUnit,
  batchDeleteInfo, findAvailPurchaseOrder, specifyPoActionAndPo
} from "@/api/proforma";
import { cal } from "@/utils/cal";
import Pagination from "@/components/Pagination/index.vue";
import CreateGroupUnit from "./components/CreateGroupUnit.vue";
import PiDetailsHeader from "./components/PiDetailsHeader.vue";
import {
  auditHold,
  generatePI,
  auditPass,
  getConversionExchangeRate,
  getSuppliersList,
} from "@/api/inquiry";
import LookRemark from "./components/lookRemark.vue"
import PiHistoryPrice from "@/views-oms/asking-for-quotation-management/components/PiHistoryPrice.vue"
import ShippingRecord from "@/views-oms/asking-for-quotation-management/components/ShippingRecord.vue"
import { getExtend } from "@/api/product-number";
import { tableColVoid } from "./tableColVoid"
import {findBrandByKeyword} from "@/api/brand";
import {querySupplierProductChineseUnits} from "@/api/supplier";
import {uploadOtherInfo} from "@/api/package";
import {
  calcOverdueDays,
  calcRemainingDays, getTodayStr, parseDay,
  resolveDeliveryDate
} from "@/views-oms/sales-order-management/order/pi-details/utils";

@Component({
  name: "PIDetails",
  components: {
    Pagination,
    CreateGroupUnit,
    LookRemark,
    PiDetailsHeader,
    PiHistoryPrice,
    ShippingRecord,
    Packing: () => import("./components/Packing.vue"),
    ModifyRate: () => import("./components/ModifyRate.vue"),
    ModifyDiscounts: () => import("./components/ModifyDiscounts.vue"),
    ModifySplit: () => import("./components/ModifySplit.vue"),
  },
})
export default class extends Vue {
  @Prop({ default: false }) private isEdit: boolean;

  public productNumberId = '';
  public remarkInfo = [] as any;
  public show_remark = false;
  private showPiHistoryPrice = false;
  private piHistoryMeta = { numberType: "", number: "" };
  private piHistoryQuery = {} as Record<string, any>;
  private showShippingRecord = false;
  private shippingRecordRow = {} as Record<string, any>;
  private shippingRecordQuery = {} as Record<string, any>;
  private tableLoading = false;
  private tableMaxHeight = 400;
  private showActions = true;
  // 是否显示所有产品号码
  private isShowMore = false;
  private isShowMore2 = false;
  private isShowMore3 = false;
  private showUnit = false;
  private showPacking = false;
  private showModify = false;
  private showRate = false;
  private showSplit = false;
  private saveSubmitOrderLoading = false;
  private PIDownloadAndUpdate = false;
  private allUpdateEditNo = false;
  private downloadPIOrder = false;
  private updatePIAndOrder = false;
  private selectedItem = {} as any;
  public shippingOrder: IDefaultShippingOrderModel[] = [];
  private listLoading = true;

  private conversionExchangeRate = 0;
  private id = "";

  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [] as any[],
  };

  private listParam = {
    approvalRecordId: null,
    inquirySheetId: null,
    refNumber: null,
    refTypeId: null,
    quotedStatus: null,
    orderStatus: null,
    supplier: null,
    hqProductName: null,
    productName: null,
    type: null,
    id: null,
  };
  public searchForm = [
    {
      label: "号码",
      prop: "refNumber",
      key: "refNumber",
      type: "input",
      value: "",
      placeholder: "产品号码",
    },
    {
      label: "华强品名",
      prop: "hqProductName",
      key: "hqProductName",
      type: "input",
      value: "",
      placeholder: "华强品名",
    },
    {
      label: "ProductName",
      prop: "productName",
      key: "productName",
      type: "input",
      value: "",
      placeholder: "PRODUCT NAME",
    },
    {
      label: "供应商",
      prop: "supplierId",
      key: "supplierId",
      value: "",
      type: "select",
      placeholder: "供应商",
      remote_method: this.getSuppliersList,
      remote: true,
      options: [],
      resetKey: { label: "abbreviation", value: "id" },
    },
    {
      label: "批次号",
      prop: "batchNumber",
      key: "batchNumber",
      type: "input",
      value: "",
      placeholder: "生产批次号",
    },
    {
      label: "PO",
      prop: "poNumber",
      key: "poNumber",
      type: "input",
      value: "",
      placeholder: "PO号码",
    },
    {
      label: "状态",
      prop: "deliveryStatus",
      key: "deliveryStatus",
      value: "",
      type: "select",
      placeholder: "下单状态",
      options:
          [
            {label: "未生成", value: "未生成"},
            {label: "已生成", value: "已生成"},
            {label: "已作废", value: "已作废"}
          ],
      resetKey: { label: "label", value: "value" },
    },
  ];
  public tableCol = [
    {
      label: "S/N",
      prop: "sn",
      key: "sn",
      width: 80,
      type: "sn-popver",
      show: true,
      fixed: true,
      disabled: false,
      icon: require("@/assets/images/ic_fuzhi.png"),
      icon_key: "copy",
      icon_value: true,
      content: "复制",
      icon2: require("@/assets/images/ic_chaofa.png"),
      icon_key2: "overUnderageStatus",
      icon_value2: "OVERDELIVERY",
      content2: "超发",
      icon3: require("@/assets/images/ic_qianfa.png"),
      icon_key3: "overUnderageStatus",
      icon_value3: "UNDERDELIVERY",
      content3: "欠发",
      icon4: require("@/assets/images/ic_fuchao.png"),
      icon_key4: "overUnderageStatus",
      icon_value4: "OVERDELIVERY",
      icon_key4_1: "copy",
      icon_value4_1: true,
      content4: "复制&超发",
      icon5: require("@/assets/images/ic_fuqian.png"),
      icon_key5: "overUnderageStatus",
      icon_value5: "UNDERDELIVERY",
      icon_key5_1: "copy",
      icon_value5_1: true,
      content5: "复制&欠发",
      icon6: require("@/assets/images/ic_customer_sample.png"),
      icon_key6: "sample",
      icon_value6: true,
      icon_key6_1: "sampleType",
      icon_value6_1: "CUSTOMER",
      content6: "工厂付款，客人不收费",
      icon7: require("@/assets/images/ic_supplier_sample.png"),
      icon_key7: "sample",
      icon_value7: true,
      icon_key7_1: "sampleType",
      icon_value7_1: "SUPPLIER",
      content7: "工厂不付款，客人收费",
      icon8: require("@/assets/images/ic_sample.png"),
      icon_key8: "sample",
      icon_value8: true,
      icon_key8_1: "sampleType",
      icon_value8_1: "ALL",
      content8: "不收付样品"
    },
    {
      label: "HQ交易号码",
      prop: "hqTransactionNumber",
      key: "hqTransactionNumber",
      width: 120,
      show: true,
      fixed: true,
      disabled: false,
    },
    {
      label: "询价参照号类型",
      prop: "inquiryRefType",
      key: "inquiryRefType",
      width: 120,
      show: true,
      fixed: true,
      disabled: false,
    },
    {
      label: "询价参照号",
      prop: "inquiryRefNumber",
      key: "inquiryRefNumber",
      width: 110,
      show: true,
      fixed: true,
      disabled: false,
    },
    {
      label: "品牌",
      prop: "brand",
      key: "brand",
      width: 100,
      fixed: true,
      show: true,
      value: 'PACKING',
      type: "selectDisabled",
      remote: true,
      filterable: true,
      clearable: true,
      remote_method: this.findBrandByKeyword,
      options: [],
      optionsDisableKey:'state',
      optionsDisableValue:['CANCEL'],
      resetKey: {label: "name", value: "id"},
      textViewKey: 'deliveryStatus',
      textViewValues: ['已生成', '已作废'],
      textViewKey2: 'type',
      textViewValues2:['PACKING', 'ACCESSORIES']
    },
    {
      label: "华强品名",
      prop: "hqProductName",
      key: "hqProductName",
      width: 100,
      show: true,
      fixed: true,
      disabled: false,
    },
    {
      label: "Product Name",
      prop: "productName",
      key: "productName",
      width: 120,
      show: true,
      disabled: false,
    },
    {
      label: "DESCRIPTION1",
      prop: "description1",
      key: "description1",
      width: 130,
      show: true,
      disabled: false,
      show_key: "show1",
    },
    {
      label: "产品属性1",
      prop: "productAttribute1",
      key: "productAttribute1",
      width: 100,
      show: true,
      disabled: false,
      show_key: "show1",
    },
    {
      label: "DESCRIPTION2",
      prop: "description2",
      key: "description2",
      width: 130,
      show: true,
      disabled: false,
      show_key: "show1",
    },
    {
      label: "产品属性2",
      prop: "productAttribute2",
      key: "productAttribute2",
      width: 100,
      show: true,
      disabled: false,
      show_key: "show1",
    },
    {
      label: "DESCRIPTION3",
      prop: "description3",
      key: "description3",
      width: 130,
      show: true,
      disabled: false,
      show_key: "show1",
    },
    {
      label: "产品属性3",
      prop: "productAttribute3",
      key: "productAttribute3",
      width: 100,
      show: true,
      disabled: false,
      show_key: "show1",
    },
    {
      label: "DESCRIPTION4",
      prop: "description4",
      key: "description4",
      width: 130,
      show: true,
      disabled: false,
      show_key: "show1",
    },
    {
      label: "产品属性4",
      prop: "productAttribute4",
      key: "productAttribute4",
      width: 100,
      show: true,
      disabled: false,
      show_key: "show1",
    },
    {
      label: "工艺",
      prop: "technicDesc",
      key: "technicDesc",
      width: 90,
      show: true,
      disabled: false,
      show_key: "show1",
    },
    {
      label: "technic",
      prop: "technic",
      key: "technic",
      width: 90,
      show: true,
      disabled: false,
      show_key: "show1",
    },
    {
      label: "产品信息",
      prop: "productInfoDesc",
      key: "productInfoDesc",
      width: 100,
      show: true,
      disabled: false,
      show_key: "show1",
    },
    {
      label: "productInfo",
      prop: "productInfo",
      key: "productInfo",
      width: 110,
      show: true,
      disabled: false,
      show_key: "show1",
    },
    {
      label: "车型/Car Application",
      prop: "carApplication",
      key: "carApplication",
      width: 150,
      show: true,
      disabled: false,
      show_key: "show1",
    },

    {
      label: "接单数量",
      prop: "shipmentQuantity",
      key: "shipmentQuantity",
      width: 110,
      show: true,
      value: 'PACKING',
      type: "inputDisabledMultipleOf",
      textViewKey: 'piShipmentStatus',
      textViewValues: ['COMPLETED', 'RECEIVED_AND_PAID','CANCELLED'],
      textViewKey2: 'type',
      textViewValues2:['PACKING', 'ACCESSORIES'],
      multipleOfProp: "saleQuantityStep",
      multipleOfWarning: (row) =>
        `【接单数量】(${row.shipmentQuantity})不是【销售计价单位】(${row.saleQuantityStep})的倍数，将不能下单。`,
    },
    {
      label: "使用库存数量",
      prop: "usedInventoryQuantity",
      key: "usedInventoryQuantity",
      width: 110,
      show: true,
      disabled: false,
    },
    {
      label: "下单数量",
      prop: "deliveryQuantity",
      key: "deliveryQuantity",
      width: 110,
      show: true,
      value: 'PACKING',
      type: "inputDisabledMultipleOf",
      textViewKey: 'poOrderStatus',
      textViewValues: ['PARTIALLY_DELIVERED', 'DELIVERY_COMPLETED','WRITTEN_OFF','CANCELED'],
      textViewKey2: 'type',
      textViewValues2:['PACKING', 'ACCESSORIES'],
      multipleOfProp: "purchaseQuantityStep",
      multipleOfWarning: (row) =>
        `【下单数量】(${row.deliveryQuantity})不是【采购计价单位】(${row.purchaseQuantityStep})的倍数，将不能下单。`,
    },
    {
      label: "产品单位",
      prop: "productUnit",
      key: "productUnit",
      width: 90,
      type: "icon_edit_noValue",
      // TODO 先隐藏组合单位的创建和删除，待后续发展。
      // click: "handleCreateGroupUnit",
      // deleteClick: "deleteCreateGroupUnit",
      // icon: "el-icon-edit",
      // unrecognize: 'type',
      // value: 'PACKING',
      // show: true,
      // disabled: false,
      // width: 140,
      // whetherDeleteValue:"=",
      loading: "loading",
      options: [],
      textViewKey: 'poOrderStatus',
      textViewValues: ['PARTIALLY_DELIVERED', 'DELIVERY_COMPLETED','WRITTEN_OFF','CANCELED'],
      textViewKey2: 'type',
      textViewValues2:['PACKING', 'ACCESSORIES']
    },
    {
      label: "供应商",
      prop: "supplier",
      key: "supplier",
      width: 140,
      show: true,
      disabled: false,
      type: "selectDisabled",
      disabledKey: 'type',
      remote_method: this.getTableSuppliers,
      remote: true,
      filterable: true,
      options: [],
      resetKey: { label: "abbreviation", value: "id" },
      textViewKey: 'deliveryStatus',
      textViewValues: ['已生成', '已作废'],
      textViewKey2: 'type',
      textViewValues2:['PACKING', 'ACCESSORIES']
    },
    {
      label: "下单状态",
      prop: "deliveryStatus",
      key: "deliveryStatus",
      width: 90,
      show: true,
      disabled: false,
    },
    {
      label: "采购订单",
      prop: "purchaseOrderAction",
      key: "purchaseOrderAction",
      width: 180,
      type: "selectOrShow",
      loading: "loading",
      selectOrShow: 'selectOrShow',
      options: [],
      textViewKey: 'type',
      textViewValues:['PACKING', 'ACCESSORIES']
    },
    {
      label: "发货进度（客）",
      prop: "shipmentProgress",
      key: "shipmentProgress",
      width: 120,
      show: true,
      disabled: false,
    },
    {
      label: "交货进度（供）",
      prop: "deliveryProgress",
      key: "deliveryProgress",
      width: 120,
      show: true,
      disabled: false,
    },
    {
      label: "采购单价",
      prop: "purchaseUnitPrice",
      key: "purchaseUnitPrice",
      width: 90,
      show: true,
      disabled: false,
    },
    {
      label: "采购折后单价",
      prop: "purchaseDiscountUnitPrice",
      key: "purchaseDiscountUnitPrice",
      width: 130,
      show: true,
      disabled: false,
      isEdit: true,
      disabledKey: 'type',
      value: 'PACKING',
      type: "discountDisabledQuantityStep",
      textViewKey: 'poOrderStatus',
      textViewValues: ['PARTIALLY_DELIVERED', 'DELIVERY_COMPLETED','WRITTEN_OFF','CANCELED'],
      textViewKey2: 'type',
      textViewValues2:['PACKING', 'ACCESSORIES'],
      quantityStepProp: "purchaseQuantityStep",
      tooltipContent: (row) =>
        `采购计价单位:${row.purchaseQuantityStep}\n\n注意：【下单数量】必须是【采购计价单位】的倍数。\n\n因要满足产品的采购总价必须要两位小数以内。`,
    },
    {
      label: "采购折扣",
      prop: "purchaseDiscount",
      key: "purchaseDiscount",
      width: 90,
      show: true,
      // disabledKey: 'type',
      // disabledValue: ['PACKING','ACCESSORIES'],
      // value: 'PACKING',
      // type: "inputDisabled",
      // textViewKey: 'poOrderStatus',
      // textViewValues: ['PARTIALLY_DELIVERED', 'DELIVERY_COMPLETED','WRITTEN_OFF','CANCELED'],
      // textViewKey2: 'type',
      // textViewValues2:['PACKING', 'ACCESSORIES']
    },
    {
      label: "采购总价",
      prop: "purchaseTotalPrice",
      key: "purchaseTotalPrice",
      width: 120,
      show: true,
      disabled: false,
      type: "price_warn",
      tooltipContent: "销售总价为三位小数或以上，将不能下单",
    },
    {
      label: "销售单价",
      prop: "saleUnitPrice",
      key: "saleUnitPrice",
      width: 90,
      show: true,
      disabled: false,
      account: ['A','A_B'],
    },
    {
      label: "销售折后单价",
      prop: "saleDiscountUnitPrice",
      key: "saleDiscountUnitPrice",
      width: 130,
      // key2: "saleUnitPrice",
      show: true,
      disabled: false,
      type: "discountDisabledQuantityStep",
      account: ['A','A_B'],
      quantityStepProp: "saleQuantityStep",
      tooltipContent: (row) =>
        `销售计价单位:${row.saleQuantityStep}\n\n注意：【接单数量】必须是【销售计价单位】的倍数。\n\n因要满足产品的销售总价必须要两位小数以内。`,
    },
    {
      label: "公司定价",
      prop: "companyPrice",
      key: "companyPrice",
      width: 90,
      show: true,
      disabled: false,
      type: "discount",
      account: ['B','A_B'],
    },
    {
      label: "销售折扣",
      prop: "saleDiscount",
      key: "saleDiscount",
      width: 90,
      show: true,
      disabled: false,
    },
    {
      label: "销售总价",
      prop: "saleTotalPrice",
      key: "saleTotalPrice",
      width: 120,
      show: true,
      disabled: false,
      account: ['A','A_B'],
      type: "price_warn",
      tooltipContent: "销售总价为三位小数或以上，将不能下单",
    },
    {
      label: "销售总定价",
      prop: "companyTotalPrice",
      key: "companyTotalPrice",
      width: 100,
      show: true,
      disabled: false,
      account: ['B','A_B'],
    },
    {
      label: "折算利润率",
      prop: "conversionProfitMargin",
      key: "conversionProfitMargin",
      width: 100,
      show: true,
      // disabledKey: 'type',
      // disabledValue: ['PACKING','ACCESSORIES'],
      // type: "inputDisabled",
      account: ['A','A_B'],
      // textViewKey: 'poOrderStatus',
      // textViewValues: ['PARTIALLY_DELIVERED', 'DELIVERY_COMPLETED','WRITTEN_OFF','CANCELED'],
      // textViewKey2: 'type',
      // textViewValues2:['PACKING', 'ACCESSORIES']
    },
    {
      label: "折算利润额",
      prop: "conversionProfitAmount",
      key: "conversionProfitAmount",
      width: 100,
      show: true,
      disabled: false,
      account: ['A','A_B'],
    },
    {
      label: "PO号码",
      prop: "poNumber",
      key: "poNumber",
      width: 120,
      show: true,
      disabledKey: 'type',
      disabledValue: ['PACKING','ACCESSORIES'],
      value: 'PACKING',
      type: "inputDisabled",
      textViewKey: 'poOrderStatus',
      textViewValues: ['PARTIALLY_DELIVERED', 'DELIVERY_COMPLETED','WRITTEN_OFF','CANCELED'],
      textViewKey2: 'type',
      textViewValues2:['PACKING', 'ACCESSORIES']
    },
    {
      label: "订单拆分",
      prop: "purchaseOrderGroup",
      key: "purchaseOrderGroup",
      width: 90,
      show: true,
      disabledKey: 'type',
      disabledValue: ['PACKING','ACCESSORIES'],
      value: 'PACKING',
      type: "inputDisabled",
      textViewKey: 'deliveryStatus',
      textViewValues: ['已生成', '已作废'],
      textViewKey2: 'type',
      textViewValues2:['PACKING', 'ACCESSORIES']
    },
    {
      label: "生产批次号",
      prop: "batchNumber",
      key: "batchNumber",
      width: 110,
      show: true,
      disabledKey: 'type',
      disabledValue: ['PACKING','ACCESSORIES'],
      value: 'PACKING',
      type: "inputDisabled",
      textViewKey: 'poOrderStatus',
      textViewValues: ['PARTIALLY_DELIVERED', 'DELIVERY_COMPLETED','WRITTEN_OFF','CANCELED'],
      textViewKey2: 'type',
      textViewValues2:['PACKING', 'ACCESSORIES']
    },
    {
      label: "出货备注",
      prop: "shippingRemark",
      key: "shippingRemark",
      width: 120,
      type: "remark",
      click: "handleRemark2",
      length: 255,
      show: true,
      disabled: false,
    },
    {
      label: "产品备注",
      prop: "remark",
      key: "remark",
      width: 120,
      type: "remark",
      show: true,
      disabled: false,
      length: 255,
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      width: 320,
      type: "actions",
      options: [
        {
          name: "发货记录",
          code: "",
          click: "handleShippingRecord",
          disabled: (row) => !this.isShippingRecordClickable(row),
        },
        {
          name: "包装与配件",
          code: "",
          click: "handleEditPacking",
          key: "type",
          value: "PACKING",
        },
        {
          name: "包装与配件",
          code: "",
          click: "handleEditPacking",
          key: "type",
          value: "ACCESSORIES",
        },
        {
          name: "复制",
          code: "",
          click: "handleCopy",
          key: "canCopy",
          value: true,
        },
        {
          name: "查看备注",
          code: '',
          click: "handlerSeeRemark",
          nokey: "type",
          value: "PACKING",
        },
         {
          name: "取消样品",
          code: '',
          type:"multipleConditionsShow",
          click: "cancelSpecifySample",
          showKey1: "type",
          showKey1Value: "PRODUCT",
          showKey2: "sample",
          showKey2Value: true,
        },
        {
          name: "样品",
          code: '',
          type: "more",
          showKey1: "type",
          showKey1Value:["PRODUCT"],
          showKey2: "sample",
          showKey2Value:false,
          actions: [
            {
              name: "客人样品",
              code: '',
              click: "specifyCustomerSample"
            },
            {
              name: "供应商样品",
              code: '',
              click: "specifySupplierSample"
            },
            {
              name: "纯样品",
              code: '',
              click: "specifyAllSample"
            }
          ]
        },
        {
          name: "删除",
          code: "",
          click: "handleDelete",
          type: "delete"
        }
      ],
      show: true,
      disabled: false,
    },
  ] as any;
  public customerInfo = {} as any;
  public piInfo = {} as any;
  public shipmentStatusList = [];
  private tableRenderKey = 0;

  private updateOrderAssociationLoading = false;

  created() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id as string;
      this.init();
    } else {
      this.id = this.$route.params.id as string;
      this.init();
    }
  }

  mounted() {
    this.updateTableMaxHeight();
    window.addEventListener("resize", this.updateTableMaxHeight);
  }

  activated() {
    this.init();
    this.$nextTick(() => {
      this.updateTableMaxHeight();
    });
  }

  beforeDestroy() {
    window.removeEventListener("resize", this.updateTableMaxHeight);
  }

  private updateTableMaxHeight() {
    this.$nextTick(() => {
      const wrap = this.$refs.tableWrap as HTMLElement;
      if (!wrap) {
        return;
      }
      const height = wrap.clientHeight;
      this.tableMaxHeight = height > 200 ? height : 200;
    });
  }

  private toggleActions() {
    this.showActions = !this.showActions;
    this.updateTableMaxHeight();
  }

  private init() {
    this.getPiInfo();
    this.getConversionExchangeRate();
    this.getPiCustomerShipmentStatus();
    this.getList();
  }

  private async getPiCustomerShipmentStatus() {
    const res: any = await getPiCustomerShipmentStatus();
    res.forEach((item) => {
      item.id = item.name;
      item.name = item.desc;
    });
    this.shipmentStatusList = res;
  }

  private async getTableSuppliers(name = "") {
    const res: any = await this.getSuppliers(name);
    let index = this.tableCol.findIndex((item) => {
      return item.key === "supplier";
    });
    this.tableCol[index].options = res;
  }

  private async getSuppliers(name = "") {
    const res: any = await getSuppliersList({ abbreviation: name });
    return res;
  }

  public async selectChange({ val, row, column }) {
    if (column.key === 'supplier') {
      try {
        await this.updateSupplierBySelected(val, row.row.id);
        this.successMessage("更新供应商");
        await this.getList();
      } catch (e) {
        console.error(e);
      }
    }
    if (column.key === 'brand'){
      try {
        await this.updateBrandBySelected(val, row.row.id);
        this.successMessage("更新品牌");
        await this.getList();
      } catch (e) {
        console.error(e);
      }
    }
    if (column.key === 'productUnit') {
      try {
        await updateProductUnit(row.row.id, val.split("/")[0]);
        this.successMessage("更新产品单位");
        await this.getList();
      } catch (e) {
        console.error(e);
      }
    }
    if (column.prop === 'purchaseOrderAction') {
      try {
        await specifyPoActionAndPo(row.row.id, val);
        this.successMessage("指定采购订单");
        await this.getList();
      } catch (e) {
        console.error(e);
      }
    }
  }

  private async updateSupplierBySelected(selectedSupplierId:string, curInfoId:string) {
       let params = {
      ids: [curInfoId],
      supplierId: selectedSupplierId,
    };
    try {
      await updatePiSupplier(params)
        .then((res) => {
          this.confirmSuccess("更新供应商");
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (e) {
      //   this.$set(row.row, "supplier", "");
    }
  }
  private gotoDocumentFlow() {
    this.$router.push({
      name: "DocumentFlow",
      params: { type: "PI", documentId: this.id },
    });
  }
  public isExporting = false;
  public async handleDownloadPi(accountTypeByOperation:string) {
    try {
      this.PIDownloadAndUpdate = true;
      await this.$confirm("您需要什么形式的下载", "提示", {
        confirmButtonText: "全部下载",
        cancelButtonText: "勾选下载",
        distinguishCancelAndClose: true,
        type: "success",
      })
      await downloadPiDetail(this.id, accountTypeByOperation)
    } catch (err) {
      if (err === "cancel") {
        if (this.selectedRows.length !== 0) {
          const ids = this.selectedRows.map(i => i.id)
          await downloadPiDetail(this.id, accountTypeByOperation, ids)
        } else {
          this.$notify({
            title: "提示",
            message: "请选择数据",
            type: "warning",
            duration: 2000,
          });
        }
      }
    } finally {
      this.PIDownloadAndUpdate = false;
    }
  }
  // handleDownloadTemplate
  public async handleDownloadTemplate(account: string) {
    this.downloadPIOrder = true;
    await downloadPiTemplate({ id: this.id, account: account })
      .then((res) => {
        this.downloadPIOrder = false;
      })
      .catch((err) => {
        this.downloadPIOrder = false;
      });
  }

  public async downloadPiPackageInfo() {
    await downloadPiPackageInfo({
      id: this.id,
    });
  }

  public async downloadOtherInfo() {
    const loading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    try {
      await downloadOtherInfo({
        id: this.id,
      });
    } catch (err) {
      console.log(err);
    } finally {
      loading.close();
    }
  }
  public async downloadBackupOtherInfo() {
    const loading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    try {
      await downloadBackupOtherInfo({
        id: this.id,
      });
    } catch (err) {
      console.log(err);
    } finally {
      loading.close();
    }
  }

  private handleUpload1() {
    console.log('command')
  }

  // private handleUploadDrop() {
  //   console.log('commond')
  //   this.$refs["uploadPL"]["$refs"]["upload-inner"].handleClick();
  // }

  // 上传维护
  private async handleUpload(file: any) {
    const loading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    this.allUpdateEditNo = true;
    let formData = new FormData();
    formData.append("file", file.file);
    // formData.append("calculateType", this.calculateTypeNo);
    formData.append("calculateType", "3");
    formData.append("accountTypeByOperation", this.accountTypeByOperation);
    await uploadPiDetail(this.id, formData).then(res => {
      this.allUpdateEditNo = false;
      this.getList();
      loading.close();
      this.$notify({
        title: "成功",
        message: "操作成功",
        type: "success",
        duration: 2000,
      });
    }).catch(err => {
      console.log(err)
      loading.close();
      this.allUpdateEditNo = false;
      this.getList();
    });
  }
  private files = [];

  private addFile(file: File) {
    this.files.push(file);
  }

  public  successMessage(message:string) {
    this.$notify({
      title: "成功",
      message: message + "成功",
      type: "success",
      duration: 2000,
    });
  }
  public querySearch(data) {
    this.table.pageNumber = 1;
    this.listParam = data && data !== "reset" ? data : {};
    this.getList();
  }

  private async getSuppliersList(name = "") {
    const res: any = await this.getSuppliers(name);
    this.searchForm[3].options = res;
  }

  private handleFilter() {
    this.table.pageNumber = 1;
    this.getList();
  }

  public handleCommand(command) {
    console.log("command",command);
    this[command]();
  }

  // 添加
  private handleAddPacking() {
    this.selectedItem = {};
    this.showPacking = true;
  }

  // 编辑
  private handleEditPacking(scope: any) {
    this.selectedItem = scope.row;
    this.showPacking = true;
  }

  // 挂起
  private async handleAuditHold() {
    this.$prompt("请输入挂起原因", "挂起", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      inputType: "textarea",
    })
      .then(async ({ value }: any) => {
        if (!value) {
          this.$message.error("请输入挂起原因");
          return;
        }
        await auditHold({
          id: this.customerInfo.approvalRecordId,
          remark: value,
        });
        this.$notify({
          title: "成功",
          message: "挂起成功",
          type: "success",
          duration: 2000,
        });
        this.getList();
      })
      .catch(() => {
        // empty
      });
  }

  private getOrderMessage() {
    let message = "";
    const remainingDays = calcRemainingDays(this.piInfo);
    const overdueDays = calcOverdueDays(this.piInfo);
    if (!this.piInfo.orderPlacementTime) {
      const deliveryDate = parseDay(getTodayStr()).clone().add(this.piInfo.deliveryDays, "day").format("YYYY-MM-DD");
      message = `本次为首次下单，对客人的【交货期】为【${this.piInfo.deliveryDays}】天，要于【${deliveryDate}】之前完成交货，确定吗？`;
    } else if (remainingDays !== "" && remainingDays !== "-" && remainingDays !== "无" && remainingDays != null) {
      const deliveryDate = resolveDeliveryDate(this.piInfo);
      message = `此PI要于【${deliveryDate}】之前完成交货，目前还剩余【${remainingDays}】天，确定追加新订单/新型号吗？`;
    } else if (overdueDays !== "" && overdueDays !== "-" && overdueDays != null) {
      const deliveryDate = resolveDeliveryDate(this.piInfo);
      message = `此PI要于【${deliveryDate}】之前完成交货，目前已超时【${overdueDays}】天，确定追加新订单/新型号吗？`;
    } else {
      message = "异常，无法确认下单情况和交货日期，请联系管理员";
    }
    return message;
  }

  //   确认下单
  private async handleConfirmOrder() {
    try {
      await this.$confirm(this.getOrderMessage(), "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      });

      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      try {
        await confirmOrder(this.id, null);
        this.confirmSuccess("下单");
        (this.$refs.table as any).$refs.table.clearSelection();
       await this.getList();
      } catch (error) {
        console.error('下单失败:', error);
      } finally {
        loading.close();
      }
    } catch (error) {
      // 用户取消操作
      console.error('用户取消确认:', error);
    }
  }

  private async handlePartConfirmOrder() {
    if (this.selectedRows.length === 0) {
      this.$notify({
        title: "提示",
        message: "请勾选产品。",
        type: "warning",
        duration: 2000,
      });
      return;
    }
    try {
      await this.$confirm(this.getOrderMessage(), "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      });

      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      try {
        await confirmOrder(this.id, this.selectedRows.map(item => item.id));
        this.confirmSuccess("部分下单");
        (this.$refs.table as any).$refs.table.clearSelection();
        await this.getList();
      } catch (error) {
        console.error('下单失败:', error);
      } finally {
        loading.close();
      }
    } catch (error) {
      // 用户取消操作
      console.error('用户取消确认:', error);
    }
  }
  private async handleUpdatePo() {
    this.updatePIAndOrder = true;
    this.$confirm("请确认是否更新采购订单", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        await getUpdatePo(this.id,true).then((res:any) => {
          if(res.length > 0) {
            this.$notify({
              title: "提示",
              message: res,
              type: "warning",
              duration: 0,
            });
          }
        }).catch(err => {
          console.log(err);
        })
        await updatePIAndCaiGou(this.id,null)
        .then((res) => {
          this.updatePIAndOrder = false;
          this.confirmSuccess("更新采购订单");
        })
        .catch((err) => {
          this.updatePIAndOrder = false;
        });
       await this.getList();
      })
      .catch((err) => {
        this.updatePIAndOrder = false;
        console.error(err);
      });
  }

  private async handlePartUpdatePo() {
    this.updatePIAndOrder = true;
    if (this.selectedRows.length === 0) {
      this.$notify({
        title: "提示",
        message: "请勾选产品。再进行【部分更新】操作",
        type: "warning",
        duration: 2000,
      });
      return;
    }
    this.$confirm("请确认【部分】更新采购订单", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
        .then(async () => {
          await getUpdatePo(this.id,true).then((res:any) => {
            if(res.length > 0) {
              this.$notify({
                title: "提示",
                message: res,
                type: "warning",
                duration: 0,
              });
            }
          }).catch(err => {
            console.log(err);
          })
          await updatePIAndCaiGou(this.id,this.selectedRows.map(item => item.id))
              .then((res) => {
                this.updatePIAndOrder = false;
                this.confirmSuccess("更新采购订单");
              })
              .catch((err) => {
                this.updatePIAndOrder = false;
              });
        await  this.getList();
        })
        .catch((err) => {
          this.updatePIAndOrder = false;
          console.error(err);
        });
  }

  public handleCommandEdit(command) {
    this[command]();
  }

  private handleCustomer() {
    this.$router.push(`/customerInventoryManagement?id=${this.id}`);
  }

  private handleModify() {
    if (!this.selectedRows.length) {
      this.$notify({
        title: "提示",
        message: "请选择产品",
        type: "error",
        duration: 2000,
      });
      return;
    }
    this.showModify = true;
  }

  private handleRate() {
    if (!this.selectedRows.length) {
      this.$notify({
        title: "提示",
        message: "请选择产品",
        type: "error",
        duration: 2000,
      });
      return;
    }
    this.showRate = true;
  }

  private handleSplit() {
    if (!this.selectedRows.length) {
      this.$notify({
        title: "提示",
        message: "请选择产品",
        type: "error",
        duration: 2000,
      });
      return;
    }
    this.showSplit = true;
  }

  public async inputChange({ val, row, column }) {
    if (row.row.type === "PACKING") {
      this.$notify({
        title: "此项不允许修改",
        message: "此项不允许修改",
        type: "warning",
        duration: 2000,
      });
      return;
    }
    console.log(column.key);
    if (column.key === "shipmentQuantity") {
      const { shipmentQuantity } = row.row;
      this.updatePiShipmentQuantity(row.row, shipmentQuantity);
    }
    if (column.key === "deliveryQuantity") {
      const { deliveryQuantity } = row.row;
      this.updatePiDeliveryQuantity(row.row, deliveryQuantity);
    }

    if (column.key === "purchaseDiscountUnitPrice") {
      // 修改折后采购单价
      // if(val.indexOf(`%`) == -1) {
      //   val = parseFloat(val)*100 + '%'
      // }
      let params = {
        postDiscountUnitPrice: val,
      };
      await updatepurchaseUnitPrice(row.row.id, params);
      this.getList();
    }
    if (column.key === "purchaseDiscount") {
      // 采购折扣
      let purchaseDiscount = "";
      if (val.indexOf("%") === -1) {
        purchaseDiscount = (parseFloat(val) * 100 + "%").toString();
      } else {
        purchaseDiscount = val;
      }
      let params = {
        proformaInvoiceInfoIds: [row.row.id],
        purchaseDiscount: purchaseDiscount,
      };
      await updatePIDiscountAndProfit(params);
      this.getList();
    }
    if (column.key === "conversionProfitMargin") {
      // 折算利润率
      let conversionMarginProfit = "";
      if (val.indexOf("%") === -1) {
        conversionMarginProfit = (parseFloat(val) * 100 + "%").toString();
      } else {
        conversionMarginProfit = val;
      }
      let params = {
        proformaInvoiceInfoIds: [row.row.id],
        conversionMarginProfit: conversionMarginProfit,
      };
      await updatePIDiscountAndProfit(params);
      this.getList();
    }
    if (column.key === "poNumber") {
      // PO号码
      let params = {
        proformaInvoiceIds: [row.row.id],
        poNumber: val,
      };
      await putPoNumber(params);
    }
    if (column.key === "batchNumber") {
      // 生产批次号
      let params = {
        batchNumber: val,
      };
      await updateBatchNumber(row.row.id, params);
    }
    if (column.key === "purchaseOrderGroup") {
      // 订单拆分
      let params = {
        proformaInvoiceIds: [row.row.id],
        purchaseOrderGroup: val,
      };
      await updatePiPurchaseOrderGroup(params);
    }
  }

  // 修改接单数量
  private async updatePiShipmentQuantity(item, shipmentQuantity) {
    let params = {
      ids: [item.id],
      shipmentQuantity,
    };
    try {
      await updatePiShipmentQuantity(params);
      this.$notify({
        title: "提示",
        message: "修改成功",
        type: "success",
        duration: 2000,
      });
      this.getList();
    } catch (e) {
      this.getList();
    }
  }

  // 修改下单数量
  private async updatePiDeliveryQuantity(item, deliveryQuantity) {
    let params = {
      ids: [item.id],
      deliveryQuantity,
    };
    try {
      await updatePiDeliveryQuantity(params);
      this.$notify({
        title: "提示",
        message: "修改成功",
        type: "success",
        duration: 2000,
      });
      this.getList();
    } catch (e) {
      this.getList();
    }
  }

  private confirmSuccess(message:any) {
    this.$notify({
      title: "成功",
      message: !message? "操作成功" : message + "成功",
      type: "success",
      duration: 2000,
    });
    this.getList();
  }

  // 审核通过
  public async handleAuditPass() {
    this.$confirm("确定审核通过吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        await auditPass(this.customerInfo.approvalRecordId);
        this.$notify({
          title: "成功",
          message: "审核通过",
          type: "success",
          duration: 2000,
        });
        this.getList();
      })
      .catch((err) => {
        console.error(err);
      });
  }

  public async handleDelete(scope) {
    const loading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    try {
      await deletePiDetail(scope.row.id);
      this.$notify({
        title: "成功",
        message: "删除成功",
        type: "success",
        duration: 2000,
      });
      this.getList();

    } catch (err) {
      console.error(err);
    } finally {
      loading.close();
    }
  }

  // 创建组合单位
  public async handleCreateGroupUnit(scope) {
    this.selectedItem = scope.row;
    this.showUnit = true;
  }
  public loading: Boolean = false;
  private async getList() {
    this.loading = true;
    const params = {
      ...this.listParam,
      pageNumber: this.table.pageNumber,
      pageSize: this.table.pageSize,
    };
    this.listLoading = false;
    this.tableLoading = true;
    await getPiDetail(this.id, params).then(res => {
      const { total, list }: any = res
      this.table.total = +total;
      this.tableLoading = false;
      this.table.list = (list || []).map(item => {
        return { ...item,
          loading:false,
          purchaseOrderAction: this.buildPOAction(item),
          selectOrShow: item.deliveryStatus === '未生成' && item.type === 'PRODUCT'}});
      this.applyModelInfoColumns(this.table.list);
      setTimeout(() => {
        this.listLoading = false;
      }, 0.3 * 1000);
      this.updateTableMaxHeight();
    }).catch(err =>{
      this.tableLoading = false;
      console.log(err)
    });
    await getUpdatePo(this.id,false).then((res:any) => {
          if(res.length > 0) {
            this.$notify({
              title: "提示",
              message: res,
              type: "error",
              duration: 0,
            });
          }
        }).catch(err => {
          console.log(err);
        })
  }

  //   deliveryProgress
  private async getDeliveryProgress(item) {
    this.$set(item, "deliveryProgress", "0/0");
  }

  // 填写备注
  public async handleRemark(item) {
    try {
      let data = {
        remark: item.remark,
      };
      await updatePiRemark(item.id, data);
      this.$notify({
        title: "成功",
        message: "操作成功",
        type: "success",
        duration: 2000,
      });
      await this.getList();
    } catch (e) {
      await this.getList();
    }
  }
  public async handleRemark2(item) {
    try {
      let data = {
        remark: item.remark
      }
      await putShippingRemark(item.id, data);
      this.$notify({
        title: "成功",
        message: "操作成功",
        type: "success",
        duration: 2000,
      });
      await this.getList();
    } catch (e) {
      await this.getList();
    }
  }

  // 复制
  public async handleCopy(scoped) {
    const loading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    try {
      await copyPiDetail(this.id, scoped.row.id);
      this.$notify({
        title: "成功",
        message: "操作成功",
        type: "success",
        duration: 2000,
      });
      await this.getList();
    } catch (e) {
      await this.getList();
    }finally {
      loading.close();
    }
  }

  private async getPiInfo() {
    const res: any = await getPiInfo(this.id);
    this.piInfo = res;
    if(this.piInfo.status === '已作废') {
      this.tableCol = tableColVoid.map((column) => ({ ...column }));
      this.applyModelInfoColumns(this.table.list);
      this.tableRenderKey += 1;
    }
    this.updateTableMaxHeight();
  }

  private applyModelInfoColumns(list: any[]) {
    this.tableCol = this.tableCol.filter((item) => item.show_key !== "show2");
    if (!list || list.length === 0) {
      return;
    }
    const models = Array.isArray(list[0].modelInfoRes) ? list[0].modelInfoRes : [];
    if (models.length === 0) {
      return;
    }
    let insertIndex = this.tableCol.findIndex((item) => item.key === "productName");
    if (insertIndex === -1) {
      const hqIndex = this.tableCol.findIndex((item) => item.key === "hqProductName");
      insertIndex = hqIndex === -1 ? this.tableCol.length : hqIndex + 1;
    }
    models.forEach((model, index) => {
      this.tableCol.splice(insertIndex + index, 0, {
        label: model.typeName,
        prop: "num" + index,
        key: "num" + index,
        type: "productNumber",
        show: true,
        disabled: false,
        show_key: "show2",
        width: 110,
        typeId: model.typeId,
      });
    });
    list.forEach((item) => {
      const itemModels = Array.isArray(item.modelInfoRes) ? item.modelInfoRes : [];
      itemModels.forEach((model, index) => {
        this.$set(item, `num${index}`, model.number);
      });
    });
    console.log(this.tableCol);
  }

  // 折算汇率
  private async getConversionExchangeRate() {
    const res: any = await getConversionExchangeRate({});
    this.conversionExchangeRate = +res.conversionExchangeRateUsd;
  }

  // 销售总金额 * 折算汇率 = 销售总金额（人民币）
  // 折算利润额 = 销售总金额（人民币）- 采购总价
  // 计算折算利润额
  private computedTotalAmount(item) {
    let conversionProfitAmount = 0;
    const { saleTotalPrice, purchaseTotalPrice } = item;
    const { conversionExchangeRate } = this;
    conversionProfitAmount = (
      conversionExchangeRate * saleTotalPrice -
      purchaseTotalPrice
    ).toFixed(2) as any;
    this.$set(item, "conversionProfitAmount", conversionProfitAmount);
  }

  // 自动计算
  private async handleCalculate(item) {
    const purchaseDiscount = this.getDiscount(item.purchaseDiscount || 0);
    const purchaseDiscountUnitPrice = +cal.cheng(
      +cal.jian(1, purchaseDiscount),
      +item.purchaseUnitPrice || 0
    );
    this.$set(
      item,
      "purchaseDiscountUnitPrice",
      purchaseDiscountUnitPrice.toFixed(2) || 0
    );
    // 获取采购总价
    const purchaseTotalPrice = +cal.cheng(
      purchaseDiscountUnitPrice.toFixed(2),
      item.deliveryQuantity || 0
    );
    this.$set(item, "purchaseTotalPrice", purchaseTotalPrice);
    // saleDiscount
    const saleDiscount = this.getDiscount(item.saleDiscount);
    // saleUnitPrice
    let saleDiscountUnitPrice = +cal.cheng(
      +cal.jian(1, saleDiscount),
      item.saleUnitPrice
    );
    saleDiscountUnitPrice = saleDiscountUnitPrice.toFixed(2) as any;
    this.$set(item, "saleDiscountUnitPrice", saleDiscountUnitPrice);
    const saleTotalPrice = (
      item.saleDiscountUnitPrice * item.deliveryQuantity
    ).toFixed(2) as any;
    this.$set(item, "saleTotalPrice", saleTotalPrice);
    this.computedTotalAmount(item);
  }

  private getDiscount(val) {
    if (`${val}`.indexOf("%") === -1) {
      return val;
    }
    const discountDecimal = parseFloat(val) / 100;
    return discountDecimal;
  }

  private calculateTypeNo = 0 as any;
  private accountTypeByOperation = 'A';
  private filesNo = [] as any;

  private addFileNo(file: File) {
    this.filesNo.push(file);
  }

  private handleClickNo(accountTypeByOperation:string) {
    this.calculateTypeNo = 0;
    this.accountTypeByOperation = accountTypeByOperation;
    this.$refs['uploadPL']["$refs"]['upload-inner'].handleClick();
  }
  private handleClickNo1() {
    this.calculateTypeNo = 1;
    this.$refs['uploadPL']["$refs"]['upload-inner'].handleClick();
  }
  private handleClickNo2() {
    this.calculateTypeNo = 2;
    this.$refs['uploadPL']["$refs"]['upload-inner'].handleClick();
  }
  private handleClickNo3() {
    this.calculateTypeNo = 3;
    this.$refs['uploadPL']["$refs"]['upload-inner'].handleClick();
  }

  private handleSuccess() {
    this.showPacking = false;
    this.showUnit = false;
    this.selectedRows = [];
    (this.$refs.table as any).$refs.table.clearSelection();
    this.getList();
  }

  private handleProductNumberClick({ row, column }) {
    const number = row[column.prop];
    if (number === null || number === undefined || String(number).trim() === "") {
      return;
    }
    const index = Number(String(column.prop).replace("num", ""));
    const model = Array.isArray(row.modelInfoRes) ? row.modelInfoRes[index] : null;
    this.piHistoryMeta = {
      numberType: (model && model.typeName) || column.label || "",
      number,
    };
    this.piHistoryQuery = {
      piId: this.id,
      detailId: row.id,
      numberTypeId: (model && model.typeId) || column.typeId,
      number,
      customerId: this.piInfo.customerId,
    };
    this.showPiHistoryPrice = true;
  }

  private handleShippingRecord(scope: any) {
    const row = scope.row || {};
    if (!this.isShippingRecordClickable(row)) {
      return;
    }
    this.shippingRecordRow = {
      pi: this.piInfo.piNumber,
      piInfoId: row.id,
      sn: row.sn,
      transactionNumber: row.hqTransactionNumber,
      saleDiscountPrice: row.saleDiscountUnitPrice,
      customerOrderQty: row.shipmentQuantity,
      currency: this.piInfo.currency,
    };
    this.shippingRecordQuery = {
      piId: this.id,
      detailId: row.id,
    };
    this.showShippingRecord = true;
  }

  private isShippingRecordClickable(row: any) {
    if (row.type === "ACCESSORIES") {
      return false;
    }
    return this.getShipmentProgressDenominator(row.shipmentProgress) > 0;
  }

  private getShipmentProgressDenominator(shipmentProgress?: string) {
    if (shipmentProgress == null || shipmentProgress === "") {
      return 0;
    }
    const parts = String(shipmentProgress).split("/");
    if (parts.length < 2) {
      return 0;
    }
    const denominator = Number(String(parts[0]).trim());
    return Number.isNaN(denominator) ? 0 : denominator;
  }

  // 点击是否展示所有产品号码
  private showMore() {
    this.isShowMore = !this.isShowMore;
  }

  private showMore2() {
    this.isShowMore2 = !this.isShowMore2;
  }

  private showMore3() {
    this.isShowMore3 = !this.isShowMore3;
  }

  private selectedRows: IDefaultShippingOrderModel[] = [];

  private onSelectionChange(rows: IDefaultShippingOrderModel[]) {
    this.selectedRows = rows;
  }

  private async handlerSeeRemark(row) {
    if(!row.row.productNumberId) {
      this.$notify({
        title: "提示",
        message: "未匹配到productNumberId",
        type: "error",
        duration: 2000
      });
      return
    }
    // 查看备注
    this.productNumberId = row.row.productNumberId
    await getExtend(row.row.productNumberId).then((res:any) => {
      this.remarkInfo = res
      this.show_remark = true
    }).catch(err => {
      console.log(err)
    })
  }

  private removeRemark(index) {
    this.remarkInfo.splice(index,1)
  }

  private addRemark() {
    this.remarkInfo.push({id: null,type: '',value: ''})
  }

  private async deleteCreateGroupUnit(row) {
   await deleteCombinedUnit(row.row.id)
   .then(() =>   this.$notify({
            title: "成功",
            message: "删除组合单位成功",
            type: "success",
            duration: 2000,
          }))
   .catch(err => {
      console.log(err)
    });
  await this.getList();
  }

  private async  findBrandByKeyword(name = ""){
    const data:any = await findBrandByKeyword(this.piInfo.customerId,name);
    let index = this.tableCol.findIndex((item) => {
      return item.key === 'brand'
    });
    this.tableCol[index].options = data;
  }

  private async updateBrandBySelected(selectedBrandId:string, curInfoId:string) {
    await updateBrand(curInfoId, selectedBrandId)
    .then((res) => {
        this.confirmSuccess("更新品牌");
    })
    .catch((err) => {
      console.error(err);
    });
  }
  // 下拉框调起上传框
  private uploadOtherInfo() {
     this.$refs['uploadOtherInfo']["$refs"]['upload-inner'].handleClick()
  }

  // 上传维护额外信息
  private async handlerUploadOtherInfo(file: any) {
    const loading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    let formData = new FormData();
    formData.append("file", file.file);
    formData.append("customerId", this.piInfo.customerId);
    formData.append("cover", 'false');
    formData.append("autoIncrementSn", 'true');
    await uploadOtherInfo(formData)
      .then(() => {
        loading.close();
        this.confirmSuccess('上传额外信息');
      })
      .catch((err) => {
        loading.close();
        console.error(err)
      });
  }

  private async downloadLabelInfo() {
    const loading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    try {
    await downloadLabelInfo(this.id);
    }catch (err) {
      console.error(err);
    }finally {
      loading.close();
    }
  }

  // 指定客人样品
  private async specifyCustomerSample(scope) {
    await specifySample(scope.row.id,'CUSTOMER')
    .then(() =>   this.$notify({
            title: "成功",
            message: "指定客人样品成功",
            type: "success",
            duration: 2000,
          }))
   .catch(err => {
      console.log(err)
    });
  await this.getList();
  }
  // 指定供应商样品
  private async specifySupplierSample(scope) {
    await specifySample(scope.row.id,'SUPPLIER')
    .then(() =>   this.$notify({
            title: "成功",
            message: "指定供应商样品成功",
            type: "success",
            duration: 2000,
          }))
   .catch(err => {
      console.log(err)
    });
  await this.getList();
  }
  // 指定客人+供应商样品
  private async specifyAllSample(scope) {
    await specifySample(scope.row.id,'ALL')
    .then(() =>   this.$notify({
            title: "成功",
            message: "指定客人+供应商样品成功",
            type: "success",
            duration: 2000,
          }))
   .catch(err => {
      console.log(err)
    });
  await this.getList();
  }
    // 取消样品指定
  private async cancelSpecifySample(scope) {
    await cancelSpecifySample(scope.row.id)
    .then(() =>   this.$notify({
            title: "成功",
            message: "取消指定样品成功",
            type: "success",
            duration: 2000,
          }))
   .catch(err => {
      console.log(err)
    });
  await this.getList();
  }

  private async visibleChange({val, row, column}) {
    if (!val) {
      return
    }
    row.row.loading = true;
    try {
      if(column.prop === 'productUnit'){
        let filterElement = this.tableCol.filter(item => item.prop === 'productUnit')[0];
        let units:any = await querySupplierProductChineseUnits(row.row.supplier, row.row.hqProductName);
        filterElement.options = units.map(item => ({ label: item.chineseUnit + '/' + item.englishUnit, value: item.chineseUnit + '/' + item.englishUnit}));
        await this.$nextTick();
      } else {
        if (column.prop === 'purchaseOrderAction') {
          let filterElement = this.tableCol.filter(item => item.prop === 'purchaseOrderAction')[0];
          let availPurchaseOrders: any = await findAvailPurchaseOrder(this.id, row.row.supplierId, row.row.type);
          let disabledStatues: string[] = ['DELIVERY_COMPLETED', 'WRITTEN_OFF', 'CANCELED'];
          filterElement.options = availPurchaseOrders.map(item => ({
            label: item.action.name === 'APPEND_TO_EXISTING' ? item.poNumber + ' - ' + item.poOrderStatus.desc : item.action.desc,
            value: item.action.name === 'APPEND_TO_EXISTING' ? item.poNumber : item.action.desc,
            disabled: item.action.name === 'APPEND_TO_EXISTING' && disabledStatues.includes(item.poOrderStatus.name)
          }));
          let purchaseOrderAction = row.row.purchaseOrderAction;
          let find = filterElement.options.find(item => item.value === purchaseOrderAction);
          if (find && filterElement.options[0].value !== purchaseOrderAction) {
            let selectedOption = filterElement.options.filter(item => item.value === purchaseOrderAction)[0];
           let noSelectedOptions = filterElement.options.filter(item => item.value !== purchaseOrderAction);
           noSelectedOptions.unshift(selectedOption);
           filterElement.options = noSelectedOptions;
          }
          await this.$nextTick();
        }
      }
    } finally {
      row.row.loading = false;
    }
  }

  /**
   * 手动打开批量删除的popover框。
   * @private
   */
  private batchDeleteVisible = false;

  private openBatchDeletePopover() {
    if (this.selectedRows.length === 0) {
      this.batchDeleteVisible = false;
      this.$message({
        message: "请选择要删除的行",
        type: "warning",
        duration: 2000,
      });
    } else {
      this.batchDeleteVisible = true;
    }
  }

  /**
   * 批量删除。
   * @private
   */
  private batchDeleteLoading = false;
  private async batchDelete() {
    this.batchDeleteLoading = true;
    try {
      await batchDeleteInfo(this.id,this.selectedRows.map(item => item.id));
      this.batchDeleteVisible = false;
      (this.$refs.table as any).$refs.table.clearSelection();
      await this.getList();
    } finally {
      this.batchDeleteLoading = false;
    }
  }

  private buildPOAction(item) {
  const  autoProcessActions:string[] = ['CREATE_NEW', 'NO_ACTION'];
    if (autoProcessActions.includes(item.action.name)) {
      return item.action.desc;
    }
    if (item.action.name === 'ALREADY_PLACED') {
      return item.targetPoNumber;
    }
    return item.targetPoNumber;
  }

}
